export default __webpack_public_path__ + "static/media/home_7.c1b46779.svg";